"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = numberShortener;

function numberShortener(num) {
  var i = parseInt(num, 10);

  if (isNaN(i)) {
    // eslint-disable-line no-restricted-globals
    return '';
  }

  var mil = 1000000;
  var thousand = 1000;

  if (i / thousand < thousand) {
    return "".concat(i / thousand, "K");
  }

  if (i / mil > 0) {
    i /= mil;

    if (i % 1 > 0) {
      return "".concat(i.toFixed(1), "Mil");
    }

    return "".concat(i, "Mil");
  }

  return '';
}